import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
import { Property } from '../../../../types/property';

interface PropertyChartProps {
  properties: Property[];
}

const COLORS = ['#0a8345', '#4ade80', '#86efac', '#bbf7d0'];

export const PropertyChart: React.FC<PropertyChartProps> = ({ properties }) => {
  // Calculer les statistiques par type de bien
  const typeStats = properties.reduce((acc, property) => {
    if (!acc[property.type]) {
      acc[property.type] = 0;
    }
    acc[property.type]++;
    return acc;
  }, {} as Record<string, number>);

  const data = Object.entries(typeStats).map(([name, value]) => ({
    name,
    value
  }));

  return (
    <div className="h-[400px]">
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            labelLine={false}
            outerRadius={150}
            fill="#8884d8"
            dataKey="value"
            label={({ name, percent }) => `${name} (${(percent * 100).toFixed(0)}%)`}
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};